<template>
  <ul class="flex grow flex-col gap-y-2 overflow-auto p-4">
    <slot />
  </ul>
</template>
